import { isAfter } from 'date-fns';
import { fireErrorAnalytics } from '@jira/platform__error-reporting/src/fireErrorAnalytics.tsx';
import { createTraitsSelector } from '@atlassian/jira-traits/src/TraitsStore.tsx';
import { expVal } from '@atlassian/jira-feature-experiments';

export const useIsJiraNewUserTraitSelector = () =>
	createTraitsSelector<'SITE_USER'>('SITE_USER', ({ getTraitValue }) => {
		try {
			const firstActiveDate = getTraitValue('jira_first_active');

			if (
				!firstActiveDate ||
				!(typeof firstActiveDate === 'string') ||
				firstActiveDate.trim() === ''
			) {
				return false;
			}

			return isAfter(
				new Date(firstActiveDate),
				// This is to get the target new user date from dynamic config jira-ybr-first-batch-new-users
				// https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/dynamic_configs/jira-ybr-first-batch-new-users
				// We confirm that this is a working way to get the value from the dynamic config
				// Other Jira teams are using this approach as well (filtered target app jira_web on dynamic config and confirmed)
				new Date(expVal('jira-ybr-first-batch-new-users', 'value', '2050-12-31T00:00:00Z')),
			);
		} catch (error) {
			fireErrorAnalytics({
				error: error instanceof Error ? error : undefined,
				meta: {
					id: 'useIsJiraNewUserTraitSelector',
					packageName: 'yellowBrickRoadUtils',
					teamName: 'jira-werewolves',
				},
			});
			return false;
		}
	})();
